import { useEffect } from "react";
import LoginModalStyleWrapper from "./checkoutModal.style";

import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import Button from "../../button";

const CheckoutModal = () => {

  const handleButtonClick = () => {
    const redirectUrl = "/wizard";
    window.location.href = redirectUrl;
  };

  useEffect(() => {
    setTimeout(handleButtonClick, 10000);
  }, []);
  return (
    <>
      <LoginModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>Error</h2>
            </div>
            <div className="text-center">
              <p>
                The selected lands were purchased by another user, we please try
                again
              </p>
            </div>
            <div className="text-center">
              <div>
                <Button
                  className="mt-4 mx-auto p-2"
                  variant="mint"
                  onClick={handleButtonClick}
                >
                  Wizard
                </Button>
              </div>
            </div>
            <div className="modal_bottom_shape_wrap">
              <span className="modal_bottom_shape shape_left">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
              <span className="modal_bottom_shape shape_right">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
            </div>
          </div>
        </div>
      </LoginModalStyleWrapper>
    </>
  );
};

export default CheckoutModal;
